import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import {
  EPlacingType,
  IAuctionState,
  ICalltracking,
  IPublishTermsService,
  IServicePackage,
  IServicePeriod,
  EMoneySource,
} from '../../../../reducers';
import { mapAuctionTerm } from './mapAuctionTerm';
import { mapCalltrackingTerm } from './mapCalltrackingTerm';
import { mapPublishTerm } from './mapPublishTerm';

interface IGetPublishTermsParams {
  service: IPublishTermsService | null;
  servicePackage: IServicePackage | null;
  publicationPeriod: IServicePeriod | null;
  placingType: EPlacingType | null;
  auction: IAuctionState;
  isAuctionSelected: boolean;
  calltracking: ICalltracking;
  increaseToMinimalBet: boolean;
  isWithoutServices: boolean;
  minimalBet: number;
  moneySource?: EMoneySource | null;
  termsDuration: number;
}

interface IPublishTermWithMoneySource extends ICheckPublishTermSchema {
  moneySource?: EMoneySource | null;
}

export function getPublishTerms(params: IGetPublishTermsParams): IPublishTermWithMoneySource[] {
  const {
    service,
    servicePackage,
    publicationPeriod,
    placingType,
    auction,
    isAuctionSelected,
    calltracking,
    increaseToMinimalBet,
    isWithoutServices,
    minimalBet,
    moneySource,
    termsDuration,
  } = params;

  const terms: IPublishTermWithMoneySource[] = [];

  const serviceBet = service?.baseAuctionBet || 0;
  let bet = isAuctionSelected ? auction.currentBet : serviceBet;

  // В рамках эксперимента MONEY-382 нельзя ставить меньше минимальной ставки
  if (increaseToMinimalBet) {
    bet = bet < minimalBet ? minimalBet : bet;
  }

  if (placingType === EPlacingType.balance && publicationPeriod) {
    const mappedTerm = mapPublishTerm(publicationPeriod);

    terms.push(mappedTerm);
  }

  if (placingType === EPlacingType.package && servicePackage) {
    const mappedTerm = mapPublishTerm(servicePackage);

    terms.push(mappedTerm);
  }

  if (auction.isEnabled && auction.period) {
    const mappedTerm = mapAuctionTerm({
      bet: isWithoutServices ? 0 : bet,
      period: auction.period,
      days: termsDuration,
    });

    terms.push(mappedTerm);
  }

  if (calltracking.isEnabled && calltracking.period) {
    const mappedTerm = mapCalltrackingTerm({
      period: calltracking.period,
    });

    terms.push(mappedTerm);
  }

  // Добавляем moneySource для каждого элемента, нужно для выбора счёта однократного размещения
  if (moneySource) {
    terms.forEach(term => {
      term.moneySource = moneySource;
    });
  }

  return terms;
}
